import React from "react";
import Card from "./Card";

/*
 * Designed empty state — every widget has one; nothing renders blank
 * (brief §8.3). Per-screen empty states compose this with specific copy
 * and actions (e.g. search: "Clear filters" + a related topic).
 */

export default function EmptyState({ icon, title, body, actions, dark = false, className = "" }) {
  return (
    <Card dark={dark} padding="p-8" className={`text-center ${className}`}>
      <div className="flex flex-col items-center gap-3 max-w-md mx-auto">
        {icon && <span className={dark ? "text-ic-sky" : "text-ic-blue"}>{icon}</span>}
        {title && (
          <span className={`text-[18px] leading-7 font-semibold ${dark ? "text-white" : "text-black"}`}>
            {title}
          </span>
        )}
        {body && (
          <span className={`text-[14px] leading-5 ${dark ? "text-ic-lightGray" : "text-ic-slate"}`}>{body}</span>
        )}
        {actions && <div className="flex items-center gap-3 flex-wrap justify-center mt-2">{actions}</div>}
      </div>
    </Card>
  );
}
